
import { useSelector } from "react-redux"
import {
    selectCountryList,
    selectDispatchRegionList,
    selectPreviousProcedureList,
    selectSpecialCountryList,
    selectTransactionNatureList,
    selectPackageCodesList,
} from "@EUForms/selectors";

export const useDropdownList = (key, countryCode, extraParams={}) => {
    if (key === 'procedure') return useSelector(selectPreviousProcedureList)
    else if (key === 'originCountry' && countryCode === 'NL') return useSelector(selectCountryList)
    else if (key === 'originCountry' && countryCode === 'ES') return useSelector(selectSpecialCountryList)
    else if (key === 'dispatchRegion') return useSelector(selectDispatchRegionList)
    else if (key === 'preference') return useSelector(selectCountryList)
    else if (key === 'natureOfTransaction') return useSelector(selectTransactionNatureList)
    else if (key === 'type' && extraParams?.mdocumentName === 'packagesList') return useSelector(selectPackageCodesList)
    else return []
}